<div class="abono-card-page">
    <div class="section">
        <a class="back-link" (click)="goBack()">
            <i class="fa-light fa-arrow-left"></i>
            Mis abonos
        </a>

        <h2 class="section-title">Carné digital</h2>

        <div class="empty-content" *ngIf="!loaded">
            <i class="fa-light fa-spinner fa-spin"></i>
            <p>Cargando tu carnet...</p>
        </div>

        <div class="empty-content" *ngIf="loaded && loadError">
            <i class="fa-light fa-circle-exclamation"></i>
            <p>No hemos podido cargar tu carnet. Vuelve a intentarlo en unos minutos.</p>
        </div>

        <ng-container *ngIf="loaded && !loadError && seasonPass as pass">
            <div class="carnet-layout">
                <!-- El pase: identidad del club + QR de acceso -->
                <div class="digital-card">
                    <div class="card-top">
                        <span class="card-club" *ngIf="companyName">{{ companyName }}</span>
                        <span class="card-badge">
                            <i class="fa-solid fa-circle"></i>
                            {{ statusName }}
                        </span>
                    </div>

                    <div class="card-qr">
                        <qrcode
                            [qrdata]="pass.hash"
                            [allowEmptyString]="false"
                            [cssClass]="'qr-center'"
                            [colorDark]="'#1E1E2B'"
                            [colorLight]="'#ffffff'"
                            [elementType]="'canvas'"
                            [errorCorrectionLevel]="'M'"
                            [margin]="1"
                            [width]="200"
                        ></qrcode>
                    </div>

                    <div class="card-number">
                        <span class="card-number-label">Abonado nº</span>
                        <span class="card-number-value">{{ pass.member_number || '—' }}</span>
                    </div>

                    <span class="card-season">{{ title }}</span>
                </div>

                <!-- La ficha: datos legibles del abono -->
                <div class="carnet-details">
                    <span class="details-eyebrow">Carnet digital</span>
                    <h3 class="details-title">{{ title }}</h3>
                    <p class="details-club" *ngIf="companyName">{{ companyName }}</p>

                    <dl class="details-list">
                        <div class="details-row">
                            <dt>Nombre</dt>
                            <dd>{{ pass.user?.name || '—' }}</dd>
                        </div>
                        <div class="details-row">
                            <dt>Abonado nº</dt>
                            <dd>{{ pass.member_number || '—' }}</dd>
                        </div>
                        <div class="details-row" *ngIf="seatDisplay">
                            <dt>Ubicación</dt>
                            <dd>{{ seatDisplay }}</dd>
                        </div>
                        <div class="details-row" *ngIf="pass.category?.name">
                            <dt>Categoría</dt>
                            <dd>{{ pass.category?.name }}</dd>
                        </div>
                        <div class="details-row" *ngIf="pass.space?.name">
                            <dt>Recinto</dt>
                            <dd>{{ pass.space?.name }}</dd>
                        </div>
                    </dl>

                    <p class="details-hint">
                        <i class="fa-light fa-qrcode"></i>
                        Muestra este código en el control de acceso del recinto.
                    </p>

                    <!-- Las insignias son las oficiales de Google y Apple (SVG en español,
                         en assets/img/wallet). Sus guías de marca prohíben recolorearlas,
                         animarlas, taparlas, atenuarlas o ponerles sombras: la imagen es el
                         botón entero, sin fondo ni efectos propios, y el estado de carga se
                         indica en el texto de debajo, nunca encima de la insignia. -->
                    <div class="wallet-actions" *ngIf="walletEnabled">
                        <!-- Se ofrece una sola insignia, la del wallet que le sirve al
                             dispositivo (ver `appleWalletAvailable`): la de Apple en iPhone y
                             iPad, y la de Google en todo lo demás, escritorio incluido. Así no
                             se ve nunca la pareja, que descuadra porque cada marca impone su
                             propia forma y no se pueden retocar. -->
                        <button type="button" class="wallet-badge" *ngIf="!appleWalletAvailable"
                                (click)="addToGoogleWallet()"
                                [disabled]="!!walletLoading" aria-label="Añadir a Google Wallet">
                            <img src="assets/img/wallet/google-wallet-badge-es.svg" alt="Añadir a Google Wallet">
                        </button>
                        <button type="button" class="wallet-badge" *ngIf="appleWalletAvailable"
                                (click)="addToAppleWallet()" [disabled]="!!walletLoading"
                                aria-label="Añadir a Cartera de Apple">
                            <!-- El texto de la insignia oficial en español es "Añadir a Cartera
                                 de Apple", no "Apple Wallet": el alt tiene que decir lo mismo. -->
                            <img src="assets/img/wallet/apple-wallet-badge-es.svg" alt="Añadir a Cartera de Apple">
                        </button>
                        <p class="wallet-loading" *ngIf="walletLoading">
                            <i class="fa-light fa-spinner fa-spin"></i>
                            Generando el pase…
                        </p>
                        <p class="wallet-error" *ngIf="walletError">{{ walletError }}</p>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
